<div class="is-ratio-content">
  <sd-slider #teaserSlider
    [customConfig]="mediasConfig"
    [brand]="brand"
    [mediaBanners]="mediaBanner"
    [ngClass]="contentClass"
    [itemTemplate]="teaserTpl"
    [isFullWidth]="true"
    [items]="data"
    [size]="sizesEnum.l"
    [context]="context"
    (slideChange)="onSlideChange($event)"
  />
</div>

<ng-template #teaserTpl let-item let-index="index">
  <sd-theme-wrapper [brand]="brand ? brand : item?.brand">
    <div class="c__teaser-wrapper {{item?.themesConfig ? 'is-theme-' + item?.themesConfig : ''}} {{item?.isEmbedded ? 'is-embedded' : ''}}">
      <sd-banner #mediaBanner
        [isComponentLoading]="isLoading"
        [twicPicsAutoSize]="twicPicsAutoSize || index > 0"
        [media]="item?.media"
        [videoTitle]="item?.content?.heading?.data?.title"
        [customId]="item?.id"
        [(play)]="item.play"
        (isVideoReady)="onIsVideoReady($event, index)"
        [hasAltText]="!item?.content?.heading?.data?.description && !item?.content?.heading?.data?.title"
        [isButtonSmall]="false"
        [showPlayButton]="(item?.media?.isVideo && loop) || item?.media?.isGif || !!item.play"
        [isAriaHidden]="item?.content?.heading?.data?.description && item?.content?.heading?.data?.title"
        [autoplayVideo]="autoplay && index === 0 ? autoplay : loop"
        [loopVideo]="loop"
        (mediaStatus)="item?.media?.isVideo && !loop ? onPlayStateChange($event, index) : null"
        (mediaPlay)="onVideoPlayed(item?.content?.heading?.data?.title)"
        (mediaEnded)="onVideoEnded(item?.content?.heading?.data?.title)"
        [buttonPosition]="(loop || item?.media?.isGif)
        ? item?.content?.heading?.textConfig === positionEnum.right
          ? positionEnum.left
          : (item?.content?.heading?.textConfig ? positionEnum.right : null)
        : null"
        [mediaTitle]="item?.content?.heading?.data?.title"
        [ngStyle]="{'height': 'auto'}"
        class="c__background {{(item?.content?.heading?.data?.title || item?.content?.heading?.data?.description) ? contentClass + ' has-content' : ''}}"
      />
      @if (!isPlaying) {
        <div #content class="c__container {{'is-' + (item?.content?.heading?.textConfig ? item?.content?.heading?.textConfig : positionEnum.left) }}">
          @if (item?.content?.heading?.data?.title || item?.content?.heading?.data?.description) {
            <div class="c__medias-content col-l-11 col-m-14">
              <div class="c__content {{item?.isEmbedded && item?.embeddedOpacity ? 'has-opacity-' + item?.embeddedOpacity : ''}}">
                <sd-rich-paragraph
                  [isLoading]="isLoading"
                  [brand]="brand"
                  [contentData]="item?.content"
                  [hasPlayer]="item?.media?.isVideo && (!loop && !item?.media?.isGif)"
                  [titleLevel]="titleLevel"
                  (played)="onPlay(index)"
                  (clicked)="onClick($event, item?.content?.heading?.data?.title, (index + 1))"
                  [size]="isDesktopLarge$ ? sizesEnum.xl : sizesEnum.l"
                  [parentsThemesConfig]="item?.themesConfig ? item.themesConfig : themesEnum.dark"
                  [textConfig]="item?.content?.heading?.textConfig ? item?.content?.heading?.textConfig : positionEnum.left"
                />
              </div>
            </div>
          }
        </div>
      }
    </div>
  </sd-theme-wrapper>
</ng-template>
